import { render, staticRenderFns } from "./WikiImportModal.vue?vue&type=template&id=48a26fa1&scoped=true"
import script from "./WikiImportModal.vue?vue&type=script&lang=js"
export * from "./WikiImportModal.vue?vue&type=script&lang=js"
import style0 from "./WikiImportModal.scss?vue&type=style&index=0&id=48a26fa1&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a26fa1",
  null
  
)

export default component.exports